<template>
  <div v-if="loading" class="new-chat-body-loader">
    <v-progress-circular
      color="accent"
      indeterminate
      size="64" />
  </div>
  <div v-else-if="step === 1 || step === 3" class="new-chat-body-wrapper">
    <new-chat-contacts
      :step="step"
      :contacts="contacts"
      :disable-selection="disableSelection"
      :contact-single-selection="contactSingleSelection"
      @contact:selection="$emit('contact:selection', $event)"
      @setContactSelectionOptionIsSingle="$emit('setContactSelectionOptionIsSingle', $event)" />
      <v-btn
        v-if="contactSelected"
        color="primary"
        class="mr-6 mb-6"
        elevation="0"
        fixed
        bottom
        right
        fab
        large
        @click="$emit('onNextStep')"
      >
        <v-icon size="24">mdi-arrow-right</v-icon>
      </v-btn>
  </div>
  <div v-else class="new-chat-body-wrapper">
    <div class="new-chat-body-wrapper-summary">
      <p class="new-chat-body-participants"> {{ participantsSummary }} </p>
      <new-chat-selected-contacts
        :selectedContacts="selectedContacts"
        wrap
        @contact:remove="$emit('contact:selection', $event)" />
    </div>
  </div>
</template>

<script>
import NewChatSelectedContacts from "@/components/chat/components/NewChatSelectedContacts.vue"
import NewChatContacts from "@/components/chat/components/NewChatContacts.vue"

export default {
  name: 'NewChatDialogBody',
  components: {
    NewChatSelectedContacts,
    NewChatContacts
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedContacts: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    },
    disableSelection: {
      type: Boolean,
      default: false
    },
    participantsSummary: {
      type: String,
      default: ''
    },
    contactSelected: {
      type: Boolean,
      default: false
    },
    contactSingleSelection: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.new-chat-body {
  &-loader {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }

  &-wrapper {
    position: relative;
    flex: 1;
  }

  &-participants {
    color: $bh-gray--2;
    line-height: 1rem;
    font-size: 0.85rem;
    margin-bottom: 0.75rem;
  }

  &-wrapper-summary {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.5 * $gutter;
    background-color: $bh-blue--4;
    overflow: hidden;
    overflow-y: auto;
    border-radius: $gutter;
  }
}
</style>
